import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=047ddf48&"
import script from "./CustomAlert.vue?vue&type=script&lang=js&"
export * from "./CustomAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports